import axiosInstance from "@/utils/axios";

export async function getHomePageMarketPlaces(args) {
    try {
        const userId = args?.queryKey[1];
        const { data: { data: Marketplaces } } = await axiosInstance.get(`/v4/shootnewLifestyleImage/getShootMarketPlace?userId=${userId}&mode=web`);

        const list = Marketplaces.map(preset => {
            return {
                name: preset.name,
                logo: preset.logo,
                marketplace_id: preset.marketplace_id,
                size: preset.size,
                aiTaskDisable: preset?.aiTaskDisable,
                type: preset?.type
            };
        });

        return list;

    } catch (error) {
        console.error("Error in getHomePageMarketPlaces:", error);
        return [];
    }
}
